import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([
      this.authService.isLoading$,
      this.authService.isAuthenticated$,
    ]).pipe(
      filter(([isLoading]) => !isLoading),
      first(),
      map(([, isAuthenticated]) => {
        if (!isAuthenticated) {
          const target = state.url ? decodeURIComponent(state.url) : '/dashboard';
          this.authService.loginWithRedirect({ appState: { target } });
          return false;
        }
        return true;
      }),
    );
  }
}
